import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth, hasFxAccess } from '../auth/AuthContext';
import TopBanner from './TopBanner';
import EmailReauthBanner from './EmailReauthBanner';

const Layout: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isDualModule = hasFxAccess(user) && !!user?.moduleRoles?.Commodities;
  const isHomePage = location.pathname === '/' || location.pathname === '/commodities/home';

  return (
    <div className="layout-container">
      <TopBanner />
      <EmailReauthBanner />
      <main className="main-content">
        {isDualModule && isHomePage && (
          <div className="module-switcher-bar">
            <select
              className="module-switcher"
              value={location.pathname.startsWith('/commodities') ? 'Commodities' : 'FX'}
              onChange={e => navigate(e.target.value === 'Commodities' ? '/commodities/home' : '/')}
            >
              <option value="FX">FX</option>
              <option value="Commodities">{t('navigation.commoditiesSection')}</option>
            </select>
          </div>
        )}
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
